<template>
  <fin-header-footer-container content-color="#edf1f4" footer-color="#edf1f4" header-color="#edf1f4"
                               page-color="#edf1f4" vertical-centered>
    <template #header>
      <fin-registration-header/>
    </template>

    <template #default="{ footerHeight }">
      <v-row align="center" class="mx-0" justify="center">

        <v-col cols="12" style="max-width: 500px" v-if="$route.name === 'onbverify'">
          <h1 style="text-align: center; font-size: 32px;">{{ header }}</h1>
          <p class="mt-5" style="text-align: center">{{ text }}</p>
          <v-img :height="125"
                 :src="require('@/assets/onboarding/registration/'+ img.src + '.svg')" :width="img.width"
                 class="my-5"
                 contain style="margin: 0 auto;"/>

          <template v-if="verifyType === 'pre'">
            <v-btn @click="resendVerificationCode" outlined style="display: block; margin: 0 auto;" tile>
              Erneut senden
            </v-btn>
            <p class="mt-5" style="text-align: center">Nichts angekommen? Überprüfe auch deinen Spam-Ordner.</p>

            <template v-if="Array.isArray(errors)">
              <fin-error-msg v-for="(m, index) in errors.msg"
                             :key="index"
                             :msg="m"
                             style="background-color: transparent !important;"/>
            </template>
            <fin-error-msg v-else
                           :msg="errors.msg"
                           style="background-color: transparent !important;"/>
            <fin-info-msg :msg="info"/>

            <p class="mt-5" style="text-align: center" v-html="contactSupportText"/>
          </template>

          <template v-else>
            <template v-if="errors.msg !== ''">
              <p style="font-size: 14px; text-align: center;">
                <template v-if="Array.isArray(errors)">
                  <fin-error-msg v-for="(m, index) in errors.msg"
                                 :key="index"
                                 :msg="m"
                                 style="background-color: transparent !important;"/>
                </template>
                <fin-error-msg v-else
                               :msg="errors.msg"
                               style="background-color: transparent !important;"/>
                <v-btn v-if="errors.exception === 'ExpiredCodeException'"
                       class="mb-5"
                       outlined
                       style="display: block; margin: 0 auto;"
                       tile
                       @click="resendVerificationCode">
                  Erneut senden
                </v-btn>

              <p class="mt-5" style="text-align: center" v-html="contactSupportText"/>

            </template>
            <template v-else>
              <p style="text-align: center">Melde dich für die nächsten Schritte mit deinem zuvor gewählten Passwort
                an
                ({{ queryParams.mail }}).</p>
              <fin-password-input :errorMessages="form.errorPwd"
                                  :passwordCheckEnabled="false"
                                  @input="resetErrors"
                                  label="Dein Passwort"
                                  style="margin: 0 auto; max-width: 250px;"
                                  v-model="form.password"/>
              <v-btn :loading="loading"
                     :disabled="form.password.trim() === ''"
                     @click="doLoginAndGoToGetStarted"
                     dark
                     style="display: block; margin: 0 auto;"
                     tile>
                <span class="verify-reset-btn">Weiter</span>
              </v-btn>
              <p class="mt-5" style="text-align: center" v-html="contactSupportText"/>
            </template>
          </template>
        </v-col>

        <v-col cols="12" style="max-width: 500px" v-if="$route.name === 'onbreset'">
          <h1 style="text-align: center; font-size: 32px;">{{ header }}</h1>
          <p v-if="text" class="mt-5" style="text-align: center" v-html="text"/>

          <template v-if="resetType === 'pre'">
            <v-form v-model="form.valid">
              <fin-password-input :errorMessages="form.errorPwd"
                                  :password-policy="passwordPolicy"
                                  @input="resetErrors"
                                  label="Dein Passwort"
                                  show-password-policy
                                  style="max-width: 250px; margin: 0 auto 30px;"
                                  v-model="form.password"/>
              <v-btn :dark="form.valid"
                     :disabled="!form.valid"
                     :loading="loading"
                     @click="resetPassword"
                     style="display: block; margin: 0 auto;"
                     tile>
                <span class="verify-reset-btn">Passwort speichern</span>
              </v-btn>
            </v-form>
          </template>

          <template v-else>
            <v-row no-gutters>
              <v-col cols="3" style="text-align: right;">
                <v-icon class="mr-3" color="green">icon-check</v-icon>
              </v-col>
              <v-col>Dein Passwort wurde erfolgreich geändert.</v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="3" style="text-align: right;">
                <v-icon class="mr-3" color="green">icon-check</v-icon>
              </v-col>
              <v-col>
                Melde dich gleich wieder bei
                <span @click="$router.push({name: 'root'})" style="text-decoration: underline; cursor: pointer;">finCraft</span>
                an.
              </v-col>
            </v-row>
          </template>
        </v-col>
      </v-row>
    </template>

  </fin-header-footer-container>
</template>

<script>
import FinRegistrationHeader from '@/components/pages/onboarding/Step1/RegistrationHeader'
import {mapActions, mapState} from 'vuex'
import FinPwdPolicy from '@/js/finPwdPolicy'
import FinHeaderFooterContainer from '@/components/common/HeaderFooterContainer/index'
import FinPasswordInput from '@/components/common/form/PasswordInput/index'
import FinErrorMsg from '@/components/common/ErrorMsg'
import FinInfoMsg from '@/components/common/InfoMsg'
import {ERROR_TYPE, handleError} from '@/js/errorhandler/finAWSErrorHandler'
import {API} from "@/plugins/finAmplifyModules"
import {createUserDocument} from "@/js/finMutations"
import {Auth} from '@/plugins/finAmplifyModules'

export default {
  name: 'FinVerification',
  components: {
    FinInfoMsg,
    FinErrorMsg,
    FinPasswordInput,
    FinHeaderFooterContainer,
    FinRegistrationHeader
  },
  data() {
    return {
      verifyType: 'pre',
      header: 'Überprüfe deinen Posteingang',
      text: 'Verifiziere deine E-Mail-Adresse um fortzufahren.',
      contactSupportText: 'Falls du Hilfe brauchst, kontaktiere uns: <a href="mailto:support@fincraft.de">support@fincraft.de</a>.',
      img: {
        src: 'email-confirmation',
        width: '110'
      },
      queryParams: {
        mail: '',
        code: ''
      },
      showNextButton: true,
      errors: '',
      info: '',
      form: {
        valid: false,
        password: '',
        errorPwd: ''
      },
      loading: false,
      passwordPolicy: FinPwdPolicy.policy,
      resetType: ''
    }
  },
  methods: {
    ...mapActions('auth', ['updateUsername', 'signIn']),

    doVerification() {
      this.error = ''
      const {mail, code} = this.queryParams

      if (this.queryParams.mail === 'test@test.de' && this.queryParams.code === '000000') {
        // skip function was used => show success
        this.setVerifySuccess()
      } else {
        this.$Amplify.Auth.confirmSignUp(mail, code).then(data => {
          console.log('confirmSignUp TODO track', data)

          this.setVerifySuccess()
        }).catch(this.setError)
      }
    },
    resendVerificationCode() {
      if (this.queryParams.mail && this.queryParams.mail.length > 0 && this.queryParams.mail !== 'test@test.de') {
        this.error = ''
        this.info = ''

        this.$Amplify.Auth.resendSignUp(this.queryParams.mail, {
          preferredLang: 'de_DE',
          signUpHost: window.location.origin
        }).then(() => {
          this.info = 'Ein neuer Verifikations-Code wurde dir zugeschickt.'
        }).catch(this.setError)
      }
    },
    createRegulationsPrivateDocuments(identityId, email) {
      const ortUndDatum = new Date().toLocaleDateString()
      const signature = email.substring(0, email.indexOf('@'))
      this.createDocument(identityId, "bafin02", "2_Annex_2_Einwilligung_zur_elektron_Datenuebermittlung.pdf",
        "Einwilligung zur elektronischen Datenübermittlung", email, '', '',
        '', '', '', '', '',
        'true', 'true',
        'true', 'false',
        'false', 'false',
        'true', 'false', 'false',
        ortUndDatum, signature)
      this.createDocument(identityId, "bafin03", "3_Annex_3_Werbeeinwilligung.pdf",
        "Werbeeinwilligung", email, '', '',
        '', '', '', '', '',
        'true', 'true',
        'true', 'false',
        'false', 'false',
        'true', 'false', 'false',
        ortUndDatum, signature)
      this.createDocument(identityId, "bafin04", "4_Einwilligung_Datenverarbeitung.pdf ",
        "Einwilligung zur Verarbeitung personenbezogener Daten", email, '', '',
        '', '', '', '', '',
        'true', 'true',
        'true', 'false',
        'false', 'false',
        'true', 'false', 'false',
        ortUndDatum, signature)
      this.createDocument(identityId, "bafin05", "5_Kundenerstinformation.pdf ",
        "Kundenerstinformation", email, '', '',
        '', '', '', '', '',
        'true', 'true',
        'true', 'false',
        'false', 'false',
        'true', 'false', 'false',
        ortUndDatum, signature)
    },
    createDocument(userIdentityId, documentId, fileName, comment, userEmail, userLastname, userFirstname,
                   userAddressStreetAndHouseNr, userAddressPLZ, userAddressOrt, userTel, userFax,
                   acceptUseofUserDataForCurrentThemes, acceptUseofUserDataForCreationOfCustomerProfile,
                   acceptUseofUserDataForContactPerApp, acceptUseofUserDataForContactPerWhatsApp,
                   acceptUseofUserDataForContactPerSMS, acceptUseofUserDataForContactPerSocialMedia,
                   acceptUseofUserDataForContactPerEmail, acceptUseofUserDataForContactPerTel,
                   acceptUseofUserDataForContactPerFax, ortUndDatum, signature) {
      const version = 1
      const acceptRequired = true
      let input = {
        input: {
          acceptRequired: acceptRequired,
          comment: comment,
          documentId: documentId,
          formId: documentId,
          fileName: fileName,
          userIdentityId: userIdentityId,
          version: version,
          fieldValues: []
        }
      }
      if (documentId === "bafin05") {
        input.input.fieldValues.push({name: "Email_1", value: userEmail})
        input.input.fieldValues.push({name: "Name_1", value: userLastname})
        input.input.fieldValues.push({name: "Vorname_1", value: userFirstname})
        input.input.fieldValues.push({name: "Straße_1", value: userAddressStreetAndHouseNr})
        input.input.fieldValues.push({name: "PLZ_1", value: userAddressPLZ})
        input.input.fieldValues.push({name: "Ort_1", value: userAddressOrt})
        input.input.fieldValues.push({name: "Telefon_1", value: userTel})
        input.input.fieldValues.push({name: "Telefax_1", value: userFax})
        input.input.fieldValues.push({name: "Ort und Datum_1", value: ortUndDatum})
        input.input.fieldValues.push({name: "Unterschrift Kunde1", value: signature})
      } else {
        input.input.fieldValues.push({name: "E-Mail 01", value: userEmail})
        input.input.fieldValues.push({name: "Name 01", value: userLastname})
        input.input.fieldValues.push({name: "Vorname 01", value: userFirstname})
        input.input.fieldValues.push({name: "Strasse, Hausnummer 01", value: userAddressStreetAndHouseNr})
        input.input.fieldValues.push({name: "PLZ 01", value: userAddressPLZ})
        input.input.fieldValues.push({name: "Ort 01", value: userAddressOrt})
        input.input.fieldValues.push({name: "Telefon 01", value: userTel})
        input.input.fieldValues.push({name: "Telefax 01", value: userFax})
        input.input.fieldValues.push({name: "Ort, Datum", value: ortUndDatum})
        input.input.fieldValues.push({name: "Unterschrift", value: signature})
      }
      if (documentId === "bafin03") {
        input.input.fieldValues.push({name: "Execution 6", value: acceptUseofUserDataForCurrentThemes})
        input.input.fieldValues.push({name: "Execution 7", value: acceptUseofUserDataForCreationOfCustomerProfile})
        input.input.fieldValues.push({name: "Execution 8", value: acceptUseofUserDataForContactPerApp})
        input.input.fieldValues.push({name: "Execution 9", value: acceptUseofUserDataForContactPerWhatsApp})
        input.input.fieldValues.push({name: "Execution 10", value: acceptUseofUserDataForContactPerSMS})
        input.input.fieldValues.push({name: "Execution 11", value: acceptUseofUserDataForContactPerSocialMedia})
        input.input.fieldValues.push({name: "Execution 12", value: acceptUseofUserDataForContactPerEmail})
        input.input.fieldValues.push({name: "Execution 13", value: acceptUseofUserDataForContactPerTel})
        input.input.fieldValues.push({name: "Execution 14", value: acceptUseofUserDataForContactPerFax})
      }
      return new Promise((resolve, reject) => {
        API.graphql({
          query: createUserDocument,
          variables: input
        })
          .catch(reject => {
            console.error("reject", reject)
          })
      })
    },
    async doLoginAndGoToGetStarted() {
      this.loading = true
      const email = this.queryParams.mail
      const password = this.form.password
      await this.signIn({email, password})
        .then(user => {

          Auth.currentUserCredentials().then(data => {
            const identityId = data.identityId

            this.createRegulationsPrivateDocuments(identityId, email)

            const username = user.attributes['custom:profileName']
            this.updateUsername(username).then(() => {
              this.$router.push({name: 'fasttrack'})
            }).catch(e => {
              console.error('Error saving username to profile ' + username, e)
              this.$router.push({name: 'fasttrack'})
            })
          })
        })
        .catch(e => {
          const error = handleError(ERROR_TYPE.AUTH, e)
          console.error("signIn failed", error)
          this.form.errorPwd = error[0].msg
          this.loading = false
        })
    },
    setError(e) {
      this.loading = false
      this.errors = handleError(ERROR_TYPE.SIGNUP_CONFIRM, e)

      console.error('Verification TODO track and log', this.errors, e)

      let customException = ""
      let msg = ""
      if (Array.isArray(this.errors)) {
        console.error('Array.isArray(this.errors)', this.errors)
        customException = this.errors[0].exception
        msg = this.errors[0].msg
      } else {
        console.error('Array.isArray(this.errors) => else', this.errors)
        customException = this.errors.exception
        msg = this.errors.msg
      }

      if (customException) {
        if (customException.includes('AlreadyConfirmedException')) {
          if (this.authorized) {
            this.$router.push({name: 'onbgetstarted'})
          } else {
            this.setAlreadyActivated()
            return
          }
          return
        } else if (customException.includes("UserNotFoundException")) {
          this.setUserNotFoundError()
          return
        } else if (customException.includes("ExpiredCodeException")) {
          this.setExpiredError()
          return
        } else if (customException.includes("LimitExceededException")) {
          this.setLimitError(msg)
          return
        }
      }

      this.setErrorVerification()
    },
    setLimitError(msg) {
      this.errors.msg = ''
      this.header = 'Limit überschritten'
      this.text = msg
      this.img.src = 'email-confirmation-error'
      this.img.width = '225'
      this.verifyType = 'pre'
    },
    setExpiredError() {
      this.errors.msg = ''
      this.header = 'Aktivierungslink abgelaufen'
      this.text = `Dein Aktivierungslink ist abgelaufen. Klicke auf den Button um einen Neuen anzufordern.`
      this.img.src = 'email-confirmation-error'
      this.img.width = '225'
      this.verifyType = 'pre'
    },
    setUserNotFoundError() {
      this.errors.msg = ''
      this.header = 'finAccount konnte nicht aktiviert werden'
      this.text = `Benutzer ${this.queryParams.mail} wurde nicht gefunden.`
      this.img.src = 'email-confirmation-error'
      this.img.width = '225'
      this.verifyType = 'pre'
    },
    setCodeInvalid() {
      this.header = 'finAccount konnte nicht aktiviert werden'
      this.text = 'Dein Aktivierungslink scheint fehlerhaft zu sein. Versuche dir einen neuen Link zu generieren.'
      this.img.src = 'email-confirmation-error'
      this.img.width = '225'
      this.verifyType = 'pre'
    },
    setErrorVerification() {
      this.errors.msg = ''
      this.header = 'finAccount konnte nicht aktiviert werden'
      this.text = 'Überprüfe bitte die Verifikation in deiner E-Mail-Adresse.'
      this.img.src = 'email-confirmation-error'
      this.img.width = '225'
      this.verifyType = 'post'
    },
    setVerifySuccess() {
      this.errors = {
        msg: ''
      }
      this.header = 'finAccount erfolgreich angelegt'
      this.text = 'In den folgenden drei Schritten helfen wir dir dabei, dein erstes eigenes Portfolio anzulegen.'
      this.img.src = 'email-confirmation-successful'
      this.img.width = '225'
      this.verifyType = 'post'
    },
    setAlreadyActivated() {
      this.errors.msg = ''
      this.header = 'finAccount wurde bereits aktiviert'
      this.text = 'In den folgenden drei Schritten helfen wir dir dabei, dein erstes eigenes Portfolio anzulegen.'
      this.img.src = 'email-confirmation-successful'
      this.img.width = '225'
      this.verifyType = 'post'
    },
    resetErrors() {
      this.form.errorPwd = ''
    },
    resetPassword() {
      if (this.form.valid) {
        this.loading = true

        this.$Amplify.Auth.forgotPasswordSubmit(
          this.queryParams.mail,
          this.queryParams.code,
          this.form.password,
          {
            preferredLang: 'de_DE',
            signUpHost: window.location.origin
          }
        ).then(data => {
          this.loading = false
          console.log('resetPassword', data)
          this.resetType = 'post'
          this.text = ''
        }).catch(err => {
          this.loading = false
          console.error('forgotPasswordSubmit failed', err)
        })
      }
    }
  },
  computed: mapState('auth', {
    authorized: state => state.authorized
  }),
  mounted() {
    const routeName = this.$route.name
    this.queryParams.mail = this.$route.query.mail
    this.queryParams.code = this.$route.query.code

    console.log("Verif mounted", routeName, this.queryParams.mail, this.queryParams.code)
    if (this.queryParams.code) {
      if (routeName === 'onbverify' &&
        this.queryParams.mail &&
        this.queryParams.mail.length > 0 && this.queryParams.code &&
        this.queryParams.code.length === 6) {
        this.verifyType = 'post'
        this.doVerification()
      } else if (this.queryParams.code.length !== 6) {
        console.log("code ungültig")
        this.setCodeInvalid()
      }

      if (routeName === 'onbreset') {
        this.header = 'Passwort zurücksetzen'
        this.text = 'Hier kannst du ein neues finCraft Passwort vergeben'
        this.resetType = 'pre'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../styles/variables";

.verify-reset-btn {
  font-family: $body-font-family;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: normal;
  text-align: center;
  color: $fin-color-primary-light;
}
</style>
